"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_utilities_1 = require("@syl-editor/core-utilities");
var background_1 = require("@syl-editor/lib/dist/lib/formats/background");
var react_dom_1 = __importDefault(require("react-dom"));
var picker_color_1 = require("../../component/picker-color");
var ReactBackgroundController = /** @class */ (function (_super) {
    __extends(ReactBackgroundController, _super);
    function ReactBackgroundController(editor, store) {
        var _this = _super.call(this, editor, store) || this;
        _this.refactorToolbar();
        return _this;
    }
    ReactBackgroundController.prototype.refactorToolbar = function () {
        var _this = this;
        this.toolbar.handler = function () { };
        this.toolbar.getRef = function (btnDOM) {
            if (!btnDOM)
                return;
            var dom = document.createElement('div');
            var extraDom = (react_1.default.createElement(picker_color_1.ColorPicker, { mountDOM: btnDOM, name: "background", editor: _this.editor, getValue: _this.getValue, getAttrs: _this.getAttrs, defaultColor: _this.defaultColor, handler: function (_attrs) {
                    _this.editor.setFormat({ color: _attrs });
                } }));
            btnDOM.appendChild(dom);
            react_dom_1.default.render(extraDom, dom);
        };
    };
    return ReactBackgroundController;
}(background_1.BackgroundController));
var BackgroundPlugin = /** @class */ (function (_super) {
    __extends(BackgroundPlugin, _super);
    function BackgroundPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Controller = ReactBackgroundController;
        _this.Schema = background_1.Background;
        return _this;
    }
    return BackgroundPlugin;
}(core_utilities_1.SylPlugin));
exports.BackgroundPlugin = BackgroundPlugin;
//# sourceMappingURL=index.js.map